import React, { Component } from 'react'
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { CommonValidationMessages } from "../../../utils/Messages";
import moment from "moment";
import { BankMasterPopup } from './BankMasterTable';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { permission } from '../../../utils/enums/ValidationMessage';
import { decryptAES } from '../../../utils/Encryption';
import { Navigate } from 'react-router-dom';

export default class BankMaster extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.state = {
            urlId: 0,
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            bankMaster: {
                idBank: 0,
                updateStatus: 0,
                idGeneralProduct: '',
                selectedGeneralProduct: {},
                accName: '',
                bankGrp: '',
                openingBalance: '',
                openingBalanceDate: '',
                currentBalance: '',
                balanceTypeId: 1,
                balanceTypeName: 'CREDIT',
                selectedbalanceType: {},
                remarks: '',
                e_Date: "",
                aCCSubHeadList: [],
                types: [
                    {
                        value: 1,
                        label: "CREDIT",
                    },
                    {
                        value: 2,
                        label: "DEBIT",
                    }
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                // idGeneralProduct: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "account sub head"
                //         ),
                //     },
                // ],
                accName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "account name"
                        ),
                    },
                ],
                // openingBalance: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "opening balance"
                //         ),
                //     },
                // ],
                // openingBalanceDate: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "opening balance date"
                //         ),
                //     },
                // ],
                balanceTypeId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "balance type"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMasterBankSelectbyid(event.data.idBank);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState })
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.bankMaster,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let details = this.state.bankMaster;

        if (name === 'GeneralProduct') {
            details.idGeneralProduct = event.value;
            details.selectedGeneralProduct = event.label;
            // details.idGeneralProduct = { ...event };
        } else if (name === 'balanceType') {
            details.balanceTypeId = event.value;
            details.balanceTypeName = event.label;
            // details.balanceTypeId = { ...event };
        } else {
            let value = event.target.value;
            details[name] = value;
        }

        this.setState({ bankMaster: details });
    }


    setFilterParameters = (selected, drpIdentity) => {
        let details = this.state.bankMaster;
        details[drpIdentity] = selected;
        this.setState({ bankMaster: details });
    };

    resetDetailsFields = () => {
        //bankMaster: {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let bankMaster = this.state.bankMaster;
        bankMaster.idBank = 0;
        bankMaster.idGeneralProduct = '';
        bankMaster.updateStatus = 0;
        bankMaster.selectedGeneralProduct = {};
        bankMaster.accName = '';
        bankMaster.bankGrp = '';
        bankMaster.openingBalance = '';
        bankMaster.openingBalanceDate = '';
        bankMaster.currentBalance = '';
        bankMaster.selectedbalanceType = 0;
        bankMaster.bala = '';
        bankMaster.balanceTypeId = 1;
        bankMaster.balanceTypeName = 'CREDIT';
        bankMaster.selectedbalanceType = {};
        bankMaster.remarks = '';
        this.setState({
            bankMaster: bankMaster, validState: validState
        })
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_GeneralProductSelect();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Bank Master",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idBank", "sR.No"].includes(key) ? true : false,
                            // width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("opBalanceDate")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Bank Master",
                            colName: colName
                        }, () => {
                            //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            //this.gridApi.hideOverlay();
                            //this.gridApi.showNoRowsOverlay();
                            //this.getAllDropdownForEmployeeMaster();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.bankMaster;
        details.idBank = id;
        this.setState({ bankMaster: details }, () => {
            this.getMasterBankSelectbyid(this.state.bankMaster.idBank);
        });
    };

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "bankName": window.innerWidth * 0.45,
            "openingBalance": window.innerWidth * 0.05,
            "opBalanceDate": window.innerWidth * 0.05,
            "balanceType": window.innerWidth * 0.05,
        }
        return colwidth[key]
    }
    // getPinnedWidth = (key) => {
    //     const pinnedCol = {
    //         "idCashWithdraw": window.innerWidth * 0.06,
    //         "sR.No": window.innerWidth * 0.04,
    //         "employeeName": window.innerWidth * 0.18,
    //     }
    //     return pinnedCol[key]
    // }

    usp_Master_GeneralProductSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                console.log(data);
                data = data.map((x) => ({
                    value: x.idGeneralProduct,
                    label: x.productName,
                }));
                let bankMaster = this.state.bankMaster
                bankMaster.aCCSubHeadList = data;
                this.setState({
                    bankMaster: bankMaster
                }, () => {
                    //this.usp_Master_EmployeeSelect()
                }, () => {
                    if (this.gridApi) {
                        //this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
                    }
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.bankMaster;
            let requestData = {
                idBank: details.idBank,
                bankName: details.accName,
                openingBalance: Number(details.openingBalance).toFixed(2),
                opBalanceDate: (details.openingBalanceDate && details.openingBalanceDate !== 'Invalid date') ? details.openingBalanceDate : null,
                currentBalance: Number(details.openingBalance).toFixed(2),
                balanceType: details.balanceTypeName,
                remarks: details.remarks,
                e_Date: details.e_Date ? details.e_Date : new Date().toISOString(), // or null if not available
                isDeleted: false,
                deletedDate: null,
                idCompany: this.state.idCompany,
                bankGroupName: details.bankGrp,
                idAccountSubHead: details.idGeneralProduct,
            };
            this.accountMasterServices.submitBankMaster(requestData)
                .then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (this.state.bankMaster.updateStatus === 1) {
                                this.SwalServices.Success("Updated successfully.");
                            } else {
                                this.SwalServices.Success("Saved successfully.");
                            }
                            this.resetDetailsFields();
                            // Call resetFields here after submission
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            }
                            this.setState(
                                { isModalOpen: false },
                                () => {
                                    this.procSelectAllRecordsSP(); // Fetch latest records
                                }
                            );
                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                });
        }
    };

    getMasterBankSelectbyid = (id) => {
        this.accountMasterServices.getMasterBankSelectbyid(id).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let bank = this.state.bankMaster;
                let responseData = response.responseItem.responseContent[0];

                bank.idBank = responseData.idBank;
                bank.updateStatus = 1;
                bank.idGeneralProduct = responseData.idAccountSubHead;
                bank.selectedGeneralProduct = responseData.idAccountSubHead > 0 ? bank.aCCSubHeadList?.find(item => item.value === responseData.idAccountSubHead) : {};
                bank.accName = responseData.bankName;
                //bank.bankGrp = responseData. ;
                bank.openingBalance = responseData.openingBalance;
                bank.openingBalanceDate = moment(responseData.opBalanceDate).format('YYYY-MM-DD');
                bank.currentBalance = responseData.currentBalance;
                bank.balanceTypeName = responseData.balanceType;
                bank.balanceTypeId = responseData.balanceType ? bank.types?.find(item => item.label === responseData.balanceType)?.value : "";
                bank.selectedbalanceType = responseData.balanceType ? bank.types?.find(item => item.label === responseData.balanceType) : {};
                bank.remarks = responseData.remarks;
                bank.e_Date = responseData.e_Date;
                bank.bankGrp = responseData.bankGroupName;
                // employee.departmentName = responseData.idDepartment > 0 ? employee.departments?.find(item => item.value === responseData.idDepartment)?.label : "";
                // employee.selectedDepartment = responseData.idDepartment > 0 ? employee.departments?.find(item => item.value === responseData.idDepartment) : {};
                // employee.joiningDate = moment(responseData.joiningDate).format('YYYY-MM-DD');

                this.setState({
                    bankMaster: bank,
                    isModalOpen: true
                });
            }
        });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='bank-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <BankMasterPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            bankMaster={this.state.bankMaster}
                            handleChange={this.handleChange.bind(this)}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Bank master</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}